import { Record, Map, List } from 'immutable';
import { actionTypes } from './permissions.actions';
import { actionTypes as demographicsActionTypes }  from './demographics/demographics.actions';
import { Err } from '../err';

export const PermissionsState = Record({
  permissionsData: Map({}),
  permissionsSubmission: Map({}),
  permissionsResponse: Map({}),
  showEnableDemographicsModal: false,
  showDisableDemographicsModal: false,
  modalSelectedOption: null,
  demographicsCheckboxSelected: null
});

export const FetchPermissionsState = Record({
  err: null,
  isFetching: false,
  isValid: false,
  permissions: List([])
});

export const SubmitPermissionsState = Record({
  err: null,
  isSubmitting: false,
  data: null
});

export const permissionsReducer = (state = new PermissionsState(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_TOUCHPOINT_PERMISSIONS_BEGIN:
      return state.setIn(['permissionsData', action.siteId], new FetchPermissionsState({
        isFetching: true
      }));
    case actionTypes.FETCH_TOUCHPOINT_PERMISSIONS_SUCCESS:
      return state.setIn(['permissionsData', action.siteId], new FetchPermissionsState({
        permissions: new List(action.data),
        isValid: true
      }));
    case actionTypes.FETCH_TOUCHPOINT_PERMISSIONS_FAILURE:
      return state.setIn(['permissionsData', action.siteId], new FetchPermissionsState({
        err: new Err(action.err),
        isValid: true
      }));
    case actionTypes.SUBMIT_TOUCHPOINT_PERMISSIONS_BEGIN:
      return state.setIn(['permissionsSubmission', action.siteId], new SubmitPermissionsState({
        isSubmitting: true
      }));
    case actionTypes.SUBMIT_TOUCHPOINT_PERMISSIONS_SUCCESS:
      return state.setIn(['permissionsSubmission', action.siteId], new SubmitPermissionsState({
        data: action.data
      })).setIn(['permissionsData', action.siteId], new FetchPermissionsState({
        isValid: false
      })).setIn(['permissionsResponse', action.siteId], new Map({}));
    case actionTypes.SUBMIT_TOUCHPOINT_PERMISSIONS_FAILURE:
      return state.setIn(['permissionsSubmission', action.siteId], new SubmitPermissionsState({
        err: new Err(action.err)
      }));
    case demographicsActionTypes.FETCH_SETTINGS_SUCCESS:
      return state.set('demographicsCheckboxSelected', action.data.demographicsEnabled)
    case actionTypes.UPDATE_PROGRAM_TP_PERMISSIONS:
      return state.setIn(['permissionsResponse', action.siteId, action.touchpointFormId, action.programId, action.section], action.value);
    case actionTypes.OPEN_ENABLE_DEMOGRAPHICS_MODAL:
      return state.set('showEnableDemographicsModal', true);
    case actionTypes.CLOSE_ENABLE_DEMOGRAPHICS_MODAL:
      return state.set('showEnableDemographicsModal', false);
    case actionTypes.OPEN_DISABLE_DEMOGRAPHICS_MODAL:
      return state.set('showDisableDemographicsModal', true);
    case actionTypes.CLOSE_DISABLE_DEMOGRAPHICS_MODAL:
      return state.set('showDisableDemographicsModal', false);
    case actionTypes.UPDATE_MODAL_OPTION:
      return state.set('modalSelectedOption', action.value);
    case actionTypes.UPDATE_DEMOGRAPHICS_CHECKBOX:
      return state.set('demographicsCheckboxSelected', action.value);
    default:
      return state;
  }
}
